module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0133.jpg?v=ad26dc7b";